/** 
*@author: satyamurthy.a
*@Description : 
**/
import _ from 'lodash';
import ListView from './ListView';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import { constant } from './Utils/Constants';
import translation from './Utils/translation';
import Highlighter from 'react-highlight-words';
import InputComponent from '../../../AMM/Widgets/InputComponent';
import { RollbackOutlined, SearchOutlined } from '@ant-design/icons';
import { message, Input, Form, Switch, Button, DatePicker } from 'antd';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import { insert, getById, deleteItemByparentId } from './Utils/FormCalls';
import { RBSLOOKUPMaster, RBSLOOKUPITEMS } from '../../../../commons/api';

const APIList = {
  getLookupItemMasterList: `${RBSLOOKUPITEMS.GET}`,
  getLookupMasterById: `${RBSLOOKUPMaster.GET}`,
  deleteLookupItem: `${RBSLOOKUPITEMS.Delete}`,
  insertLookupItem: `${RBSLOOKUPMaster.CREATE}`
};
const LookupMasters = (props) => {
const [formObject, setFormObject] = useState({});
const [dataSource, setDataSource] = useState([]);
const [disableSubmits, setdisableSubmits] = useState(false);
const [newRecord, setNewRecord] = useState(false);
const [translationCache, setTranslationCache] = useState(props.translationCache || []);
const lookupItemRef = useRef(null);
const [searchText, setSearchText] = useState('');
const [searchedColumn, setSearchedColumn] = useState('');

const handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  setSearchText(selectedKeys[0]);
  setSearchedColumn(dataIndex);
};

const handleReset = (clearFilters, confirm) => {
  clearFilters();
  confirm();
  setSearchText('');
};

const getColumnSearchProps = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={(node) => {
          this.searchInput = node;
        }}
        placeholder={
          translation(props.translationCache, constant.search) +
          translation(props.translationCache, dataIndex)
        }
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        
        style={{
          width: 90,
          marginRight: '5px'
        }}
      >
        {translation(props.translationCache, constant.search)}
      </Button>
      <Button
        onClick={() => clearFilters && handleReset(clearFilters, confirm)}
        type='primary'
        danger
        
        style={{ width: 90 }}
      >
        {translation(props.translationCache, constant.reset)}
      </Button>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  ),
  onFilter: (value, record) =>
    record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: (text) =>
    searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    )
});

  const [columns] = useState([
    {
      title: translation(props.translationCache, constant.lookupItem),
      key: 'LookupItem',
      dataIndex: 'LookupItem',
      editable: true,
      disable: true,
      ...getColumnSearchProps('LookupItem'),
      sorter: (a, b) => a.LookupItem.localeCompare(b.LookupItem)
    },
    {
      title: translation(props.translationCache, constant.lookupText),
      key: 'LookupText',
      dataIndex: 'LookupText',
      editable: true
    },
    {
      title: translation(props.translationCache, constant.enabled),
      key: 'Enabled',
      dataIndex: 'Enabled',
      editable: true,
      ...getColumnSearchProps('Enabled'),
      sorter: (a, b) => String(a.Enabled).localeCompare(String(b.Enabled)),
      render: (text) => String(text)
    },
    {
      title: translation(props.translationCache, constant.createdBy),
      key: 'CreatedName',
      dataIndex: 'CreatedName',
      ...getColumnSearchProps('CreatedName'),
      sorter: (a, b) =>
        a.CreatedName && b.CreatedName && a.CreatedName.localeCompare(b.CreatedName)
    },
    {
      title: translation(props.translationCache, constant.createdDate),
      key: 'CreatedTime',
      dataIndex: 'CreatedTime',
      ...getColumnSearchProps('CreatedTime'),
      sorter: (a, b) =>
        new Date(moment(a.CreatedTime, 'YYYY-MM-DD HH:mm:ss').format('LLL')) -
        new Date(moment(b.CreatedTime, 'YYYY-MM-DD HH:mm:ss').format('LLL')),
      render: (text) => {
        return {
          children: <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        };
      }
    }
  ]);




  useEffect(() => {
    getLookupMasterDetails();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const getLookupMasterDetails = async () => {
    let path = props.location.pathname.split('/rubus/LookupMasterItemDetails/');
    if (path[1] !== 'new') {
      let response = await getById(APIList.getLookupMasterById, path[1], 'LookupId');
      _.cloneDeepWith(response, (value) => {
        return value !== undefined && value !== null && value.CreatedTime
          ? {
            ...value,
            ...(value['CreatedTime']
              ? (value['CreatedTime'] = moment
                .utc(value.CreatedTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null)
          }
          : _.noop();
      });
      if (response && response.status === 200) {
        if (lookupItemRef.current) {
          lookupItemRef.current.setFieldsValue(response.data ? response.data : {});
        }
        setFormObject(response && response.data ? response.data : {});
        setDataSource(
          response && response.data && response.data.Items && Array.isArray(response.data.Items)
            ? response.data.Items
            : []
        );
      }
    } else {
      const newFormObject = {
        ...formObject,
        Enabled: 'true'
      };
      lookupItemRef.current.setFieldsValue(newFormObject);
      setFormObject(newFormObject);
    }
  };

  const _deleteById = async (LookupItemId, LookupId) => {
    let response = await deleteItemByparentId(
      APIList.deleteLookupItem,
      LookupItemId,
      'LookupItemId',
      LookupId,
      'LookupId'
    );
    if (response && response.status === 200) {
      response &&
        response.message &&
        message.success(translation(translationCache, response.message));
      getLookupMasterDetails();
    }
  };

  const handleSave = (dataSource) => {
    setDataSource(dataSource);
    disableSubmit(false);
    setNewRecord(false);
  };

  const onFormSubmit = () => {
    const currentDataSource = dataSource;
    lookupItemRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...lookupItemRef.current.getFieldsValue(),
          LookupName: values['LookupName'].toUpperCase(),
          Items: currentDataSource
        };
        let response = await insert(APIList.insertLookupItem, values);
        if (response && response.status === 200) {
          if (response && response.data && response.data.message) {
            message.success(translation(translationCache, response.data.message));
            props.navigate(-1);
          }
        }
      })
      .catch(() => { });
  };

  const handleAdd = () => {
    const newData = {
      key: uuidv4(),
      LookupItem: '',
      LookupText: '',
      Enabled: true
    };
    setDataSource([...dataSource, newData]);
    setNewRecord(true);
  };

 const onFinishFailed = () => {
    message.error(translation(translationCache, 'Please Provide Required Fields'));
  };

  // const onChange = (value, key) => {
  //   const updatedFormObject = {
  //     ...formObject,
  //     [key]: value
  //   };
  //   lookupItemRef.current.setFieldsValue(updatedFormObject);
  //   setFormObject(updatedFormObject);
  // };




  const disableSubmit = (disable) => {
    setdisableSubmits(disable);
    setNewRecord(false);
  };

  const validateMessages = {
    required: translation(translationCache, '${label}') + translation(translationCache, 'is required!'),
    types: {
      email: translation(translationCache, '${label}') + translation(translationCache, 'is not a valid email!'),
      number: translation(translationCache, '${label}') + translation(translationCache, 'is not a valid number!')
    },
    number: {
      range: translation(translationCache, '${label}') + translation(translationCache, 'must be between') + translation(translationCache, '${min}') + translation(translationCache, 'and') + translation(translationCache, '${max}')
    },
    pattern: {
      mismatch: translation(translationCache, '${label}') + translation(translationCache, 'does not match pattern') + translation(translationCache, '${pattern}')
    }
  };

  return (
    <>
      <div style={{ color: 'black', fontWeight: 'bold' }}>
        <div style={{ padding: '10px 19px' }}>
          <div style={{ color: '#000', cursor: 'pointer' }}>
            <span style={{ cursor: 'pointer' }} onClick={() => props.navigate(-1)}>
              <RollbackOutlined />
              {translation(translationCache, constant.goBack)}
            </span>
          </div>
        </div>
        <Form
          name="LookupDetails"
          ref={lookupItemRef}
          autoComplete="off"
          initialValues={formObject}
          theme={themeSettings}
          layout="horizontal"
          labelCol={{ flex: '200px' }}
          labelAlign="right"
          onFinish={onFormSubmit}
          onFinishFailed={onFinishFailed}
          labelWrap
          validateMessages={validateMessages}
          wrapperCol={{ flex: 1 }}
        >
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <Button disabled={disableSubmits} htmlType="submit" type="primary">
                {translation(translationCache, constant.submit)}
              </Button>
            </Form.Item>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              label={translation(translationCache, constant.lookupCode)}
              name="LookupName"
              style={{ width: '100%', flex: '50%' }}
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%', textTransform: 'uppercase' }}
                disabled={formObject['LookupId'] ? true : false}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.description)}
              name="Description"
              style={{ width: '100%', flex: '50%' }}
              rules={[{ required: true }]}
            >
              <InputComponent style={{ width: '70%' }} />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.createdBy)}
              name="CreatedName"
              style={{ width: '100%', flex: '50%' }}
            >
              <InputComponent style={{ width: '70%' }} disabled />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.createdDate)}
              name="CreatedTime"
              style={{ width: '100%', flex: '50%' }}
            >
              <DatePicker style={{ width: '70%' }} disabled format={'YYYY-MM-DD HH:mm:ss'} />
            </Form.Item>
            <Form.Item
              name="Enabled"
              label={translation(translationCache, constant.enabled)}
              valuePropName="checked"
              style={{ width: '100%', flex: '50%' }}
            >
              <Switch />
            </Form.Item>
            <Form.Item style={{ width: '100%', flex: '50%' }} name="LookupId">
              <InputComponent style={{ display: 'none' }} />
            </Form.Item>
          </div>
        </Form>
        <Form theme={themeSettings} style={{ marginLeft: '45%' }}>
          {translation(translationCache, constant.lookupItem)}
        </Form>
        <Form>
          <Form.Item name="Lookup_Items">
            <ListView
              columns={columns}
              dataSource={dataSource}
              addRow={handleAdd}
              saveRow={handleSave}
              deleteRow={_deleteById}
              uniqueKey={'LookupItemId'}
              disableSubmit={disableSubmit}
              edit={newRecord}
            />
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(LookupMasters);